<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">      
      <div class="card-header wh-header padding-bottom-0px">
        Add Article
        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">
            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">
                <div class="row margin-bottom-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px">Category</label>
                      </div>
                      <div class="col-md-5">
                        <input type="text" class="form-control" placeholder="Category"
                               id="CurrentSaveArticleRequest.Category"
                               [(ngModel)]="CurrentSaveArticleRequest.Category"
                               name="CurrentSaveArticleRequest.Category" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" minlength="1">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName">Title</label>
                      </div>
                      <div class="col-md-4">

                        <input type="text" class="form-control" placeholder="Title"
                               id="CurrentSaveArticleRequest.Name"
                               [(ngModel)]="CurrentSaveArticleRequest.Name"
                               name="CurrentSaveArticleRequest.Name" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" minlength="1">
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-3 text-align-right padding-left-0px">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Date</label>
                      </div>
                      <div class="col-md-5">
                        <div class="date-form">
                          <input class="form-control" placeholder="Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp1" [(ngModel)]="CreatedAt" ngbDatepicker #dsF="ngbDatepicker" #DateF="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!DateF.valid && (DateF.dirty || DateF.touched) && DateF.errors.required)">(Field cannot be left blank)</small>
                          <a (click)="dsF.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                          </a>
                        </div>


                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName">Published In</label>
                      </div>
                      <div class="col-md-4">

                        <input type="text" class="form-control" placeholder="Published In"
                               id="CurrentSaveArticleRequest.PublishedIn"
                               [(ngModel)]="CurrentSaveArticleRequest.PublishedIn"
                               name="CurrentSaveArticleRequest.PublishedIn" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" minlength="1">

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName">Presented At</label>
                      </div>
                      <div class="col-md-4">

                        <input type="text" class="form-control" placeholder="Presented At"
                               id="CurrentSaveArticleRequest.PresentedIn"
                               [(ngModel)]="CurrentSaveArticleRequest.PresentedIn"
                               name="CurrentSaveArticleRequest.PresentedIn" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" minlength="1">

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName">Posted By</label>
                      </div>
                      <div class="col-md-4">

                        <input type="text" class="form-control" placeholder="Posted By"
                               id="CurrentSaveArticleRequest.PostedBy"
                               [(ngModel)]="CurrentSaveArticleRequest.PostedBy"
                               name="CurrentSaveArticleRequest.PostedBy" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" minlength="1">

                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
